import { contentAi } from '@mi-front/api-clients';
import { useIntl } from 'react-intl';
import { Page } from '../../../../components/page/Page';
import { ListingView } from '../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../core/reports/types';
import { ContentAiIcon } from '../../ContentAiIcon';
import { ContentsList } from './ContentsList';

export function ContentsListPage() {
  const { $t } = useIntl();

  return (
    <Page
      htmlTitle={$t({
        id: 'contentAi.contentsList.title',
        defaultMessage: 'Content AI - Contenidos',
      })}
    >
      <Page.Header
        icon={<ContentAiIcon />}
        title={$t({
          id: 'contentAi.title',
          defaultMessage: 'Content AI',
        })}
      />
      <ListingView<ListingType<Record<string, never>, contentAi.ThinContentDto>>
        reportFn={async (values) => {
          return contentAi.contentList({
            ...values,
            page: values.pageIndex,
          }) as any;
        }}
        Result={ContentsList}
        showEmptyResult
      />
    </Page>
  );
}
